// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var GraphBarSolid = function GraphBarSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.5 3.125c0-1.035.84-1.875 1.875-1.875h1.25c1.035 0 1.875.84 1.875 1.875v13.75c0 1.035-.84 1.875-1.875 1.875h-1.25A1.875 1.875 0 0 1 7.5 16.875zm-6.25 7.5c0-1.035.84-1.875 1.875-1.875h1.25c1.035 0 1.875.84 1.875 1.875v6.25c0 1.035-.84 1.875-1.875 1.875h-1.25a1.875 1.875 0 0 1-1.875-1.875zM15.625 3.75h1.25c1.035 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-1.25a1.875 1.875 0 0 1-1.875-1.875V5.625c0-1.035.84-1.875 1.875-1.875"
  }));
};
